import React from "react";
import {
  Input,
  Button,
  Row,
  Col,
  Icon,
  Tooltip,
  notification,
  Popconfirm,
} from "antd";
import PageLayout from "../../ui/PageLayout";
import http from "../../../axios/http";
import PlateNoBlackEdit from "./PlateNoBlackEdit";
import { global_data } from '../../ui/auth'


const deleteNotification = (type) => {
  notification[type]({
    message: "删除成功",
  });
};

class PlateNoCardIndex extends React.Component {
  columns = [
    {
      title: "车牌号",
      dataIndex: "plateNo",
      width: "15%",
    },
    {
      title: "备注",
      dataIndex: "remark",
      width: "20%",
    },
    {
      title: "有效区域",
      dataIndex: "useZone",
      width: "20%",
      render: (text, record, index) => {
        var temp = text.split(",");
        var zoneArr = [];
        temp.forEach((item) => {
          this.state.parkZones.forEach((row) => {
            if (row.code === item) {
              zoneArr.push(row.name);
            }
          });
        });
        return zoneArr.join(",");
      },
    },
    {
      title: "有效期至",
      dataIndex: "expireDate",
      width: "20%",
    },
    {
      title: "状态",
      dataIndex: "state",
      width: "10%",
      render: (text, record, index) => (
        <div>
          <Tooltip title={record.disabled ? "切换启用" : "切换禁用"}>
            {global_data.authCode.includes("BARRIER_BLACK_LIST_ENABLE")?
            <Button
              onClick={this.changeDisabled.bind(this, record)}
              style={{ color: record.disabled ? "red" : "black" }}
            >
              {record.disabled ? "禁用" : "启用"}
            </Button>
            :""}
          </Tooltip>
        </div>
      ),
    },
    {
      title: "操作",
      dataIndex: "id",
      width: "20%",
      render: (text, record, index) => (
        <div>
          {global_data.authCode.includes("BARRIER_BLACK_LIST_UPDATE")?
          <Tooltip title="修改">
            <Icon
              type="edit"
              theme="filled"
              title="修改"
              className="table-operate-icon"
              onClick={this.update.bind(this, record)}
            />
          </Tooltip>
          :""}
          <Popconfirm
            title="确定删除此项记录?"
            onConfirm={this.deleteConfirm.bind(this, record)}
            onCancel={this.deleteCancel.bind(this, record)}
            okText="Yes"
            cancelText="No"
          >
          {global_data.authCode.includes("BARRIER_BLACK_LIST_DELETE")?
          <Tooltip title="删除">
            <Icon
              type="delete"
              theme="filled"
              title="删除"
              className="table-operate-icon"
            />
          </Tooltip>
          :""}
          </Popconfirm>
        </div>
      ),
    },
  ];

  state = {
    visible: false,
    editData: {},
    loadData: "",
    queryData: {},
    parkZones: [],
  };

  loadAllZone = () => {
    http.post({
      url: "/barrier/parkZone/allZone",
      data: {},
      success: (res) => {
        this.setState({ parkZones: res });
      },
    });
  };
  componentWillMount() {
    this.loadAllZone();
  }

  add = () => {
    this.setState({ editData: { state: -1 } });
    this.showModal();
  };

  showModal = () => {
    this.setState({ visible: true });
  };
  hiddenModal = () => {
    this.setState({ visible: false });
  };

  update = (info, e) => {
    info.useZoneArr = info.useZone.split(",");
    this.setState({ editData: info });
    this.showModal();
  };

  changeDisabled = (data, e) => {
    console.log(data);
    const { id, disabled } = data;
    http.post({
      url: "/barrier/plateNoCard/setDisabled",
      data: { id, disabled: disabled ? 0 : 1 },
      success: (res) => {
        this.state.loadData(this.state.queryData);
      },
    });
  };

  deleteConfirm = (info, e) => {
    http.post({
      url: "/barrier/plateNoCard/delete",
      data: { id: info.id },
      success: (res) => {
        deleteNotification("success");
        let queryData = this.state.queryData;
        this.state.loadData(queryData);
      },
    });
  };

  deleteCancel = (info, e) => {};

  inputSearch = (value) => {
    let queryData = this.state.queryData;
    queryData["plateNo"] = value;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  };

  render() {
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <PageLayout
          condition={
            <Row>
              <Col span={8}>
                <Input.Search
                  placeholder="车牌号或备注"
                  onSearch={this.inputSearch}
                  enterButton
                />
              </Col>
              <Col span={16} style={{ textAlign: "right" }}>
                {global_data.authCode.includes("BARRIER_BLACK_LIST_ADD")?
                <Button type="primary" onClick={this.add}>
                  新增
                </Button>
                :""}
              </Col>
            </Row>
          }
          rowKey="id"
          url="/barrier/plateNoCard/queryBlack"
          columns={this.columns}
          loadData={(func) => {
            this.setState({ loadData: func });
          }}
        />
        <PlateNoBlackEdit
          visible={this.state.visible}
          onCancel={this.hiddenModal.bind(this)}
          editData={this.state.editData}
          successCallback={this.state.loadData}
          queryData={this.state.queryData}
        />
      </div>
    );
  }
}

export default PlateNoCardIndex;
